import { useState } from 'react';
import { LoaderBar, SkupremeModal } from '../../components';
import { DangerText, HoverBorderButton, StyledButton, SuccessText } from '../../elements';
import { toteLimboCheckHook } from '../../hooks/tote';
import { ToastMessage, ToteService } from '../../utility';

export function ToteResetPopup({ open, tote, onClose, refresh }) {
  const { data, loading } = toteLimboCheckHook(tote?.id);
  const [resetting, setResetting] = useState(false);

  const resetTote = async () => {
    try {
      const payload = {
        type: 'tote',
        containerId: tote?.id,
        force: !data.isInLimbo,
      };
      setResetting(true);
      await ToteService.resetContainer(payload);
      ToastMessage.success('Tote reset successfully');
      refresh();
      onClose();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setResetting(false);
    }
  };

  return (
    <SkupremeModal
      title={`Reset Tote ${tote?.toteNumber}`}
      open={open}
      onClose={onClose}
      size="mini"
    >
      {loading && <LoaderBar />}
      <div className="mb-4">
        {data?.reason && <p>{data?.reason}</p>}
        {data.isInLimbo ? (
          <SuccessText>This Tote is not in use</SuccessText>
        ) : (
          <DangerText>This Tote is in use</DangerText>
        )}
      </div>
      <div className="d-flex justify-content-end">
        <HoverBorderButton disabled={resetting} onClick={onClose}>
          Cancel
        </HoverBorderButton>
        <StyledButton
          onClick={resetTote}
          loading={resetting}
          disabled={loading || !data?.isInLimbo}
          className="ml-2"
        >
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
